















































import { Building } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class UpsertBuildingModal extends Vue {
  @Prop({ required: false }) building: Building

  private buildingSave: Building = {
    id: 0,
    name: '',
    createdOn: '',
    updatedOn: ''
  }

  @Watch('building', { deep: true })
  onBuildingChanged() {
    this.updateBuilding()
  }

  get newBuilding(): boolean {
    return this.building == null || !this.building.id
  }

  private updateBuilding() {
    if (this.building && this.building.id) {
      Vue.set(this.buildingSave, 'id', this.building.id)
      Vue.set(this.buildingSave, 'name', this.building.name)
    } else {
      this.clearForm()
    }
  }

  private formOk(): boolean {
    return !!this.buildingSave.name
  }

  hideModal() {
    this.$bvModal.hide('UpsertBuildingModal')
  }

  private saveForm(): void {
    if (!this.formOk()) {
      alert('Form not valid!')
      return
    }
    const promise = this.newBuilding
      ? ApiClient.createBuilding(this.buildingSave)
      : ApiClient.updateBuilding(this.buildingSave.id, this.buildingSave)

    promise
      .then((buildingSaved: Building) => {
        this.$emit('buildingSaved', buildingSaved)
        this.hideModal()
        this.clearForm()
      })
      .catch((ex: Error) => alert(`Error: ${ex.message}`))
  }

  private clearForm() {
    Vue.set(this.buildingSave, 'id', 0)
    Vue.set(this.buildingSave, 'name', '')
  }
}
